import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Revamp() {
  return (
    <section className="revamp p-100 text_nde">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="revamp_img">
              <StaticImage
                src="../../../images/case-studies/nde/revamp.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={650}
                height={608}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>Revamp & Maintenance</h1>
            <p>
              The client (NDE Offshore) wanted to revamp their web portals and
              enhance the backend operations to create more stable and flexible
              web-based portals for further enhancement. The following web-based
              portals needed an upgrade:
            </p>
            <ul>
              <li>Admin Portal</li>
              <li>Human Resource Portal</li>
              <li>Employee Management Portal</li>
              <li>Reporting Portal</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Revamp;
